import React , {useState} from 'react'
import { VStack, Input, Button } from '@chakra-ui/react'
import { FormControl, FormLabel } from '@chakra-ui/form-control'
import { InputGroup, InputRightElement } from "@chakra-ui/input";
import { useToast } from "@chakra-ui/toast";
import axios from 'axios';
import {useHistory} from 'react-router-dom'
import EnvRoute from '../../middleware/envRoute';
import { refreshPage } from '../../config/ChatLogistics';
const ENDPOINT = EnvRoute('prod'); 


const Login = () => {
   
    const [ email , setEmail ] = useState()
    const [ password , setPassword ] = useState()
    const [ isOnline , setIsOnline ] = useState(false)
    const [ show , setShow ] = useState(false)
    const [ loading , setLoading ] = useState(false)
   
    const toast = useToast();
    const history = useHistory()

    const handleClicK = () => {setShow(!show)}

    const submitHandler = async () => {
    setLoading(true);
    if ( !email || !password ) {
      toast({
        title: "Please Fill all the Feilds",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }
   
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      setIsOnline(true)
      const { data } = await axios.post(
        `${ENDPOINT}/api/user/login`,
        {
          email,
          password,
        },
        config
      );

      console.log("[login] data:",data);
      toast({
        title: "Login Successful",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      localStorage.setItem("userInfo", JSON.stringify(data));
      console.log("pre-update userInfo",data)
       axios.put(
        `${ENDPOINT}/api/user/update`,
        {...data},
        config
      );

      setLoading(false);
      history.push("/chats");
      refreshPage()
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
  };
  return (
    <div>
    <VStack spacing ='5px'>

      <FormControl id ="email" isrequired>
        <FormLabel>email</FormLabel>
          <Input  
            placeholder='enter email'
            border={'1px solid #868686'}
              color={'#868686'}
            onChange={(e)=>setEmail(e.target.value.toLowerCase())}
            value={email}
            />
      </FormControl>

      <FormControl id ="password" isrequired>
        <FormLabel>password</FormLabel>
        
        <InputGroup>
            <Input  
            type={show ?'text':'password'}
              placeholder='enter password'
              border={'1px solid #868686'}
              color={'#868686'}
              value={password}
              onChange={(e)=>setPassword(e.target.value)}
              />
        <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClicK}>
              {show ? "hide" : "show"}
            </Button>
        </InputRightElement>
        </InputGroup>
      </FormControl>

       <Button
        colorScheme="blue"
        width="100%"
        style={{ marginTop: 15 }}
        onClick={submitHandler}
        isLoading= {loading}
        borderRadius="10px 0px 10px 10px"

      >
        login
      </Button>

       <Button
        colorScheme="red"
        width="100%"
      borderRadius="10px 10px 10px 0px"

        

        style={{ marginTop: 15 }}
        onClick={()=>{
            setEmail("guest@example.com")
            setPassword("test")
        }}
      >
        get guest credentials
      </Button>
    </VStack>
    </div>
  )
}

export default Login